module.exports = __webpack_public_path__ + "p1_img4.jpg?933e538c9d4ffc06d4c1c88f666ab5e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img4.jpg
// module id = 106
// module chunks = 0